import React from "react";
import $filters, { Filter } from "@/data/filters.constants";
import Dropdown, {
  DropdownSelectorOption,
} from "@/components/pages/home/components/searchbar/components/dropdown";
import { useGenderDropdownContext } from "@/components/pages/home/providers/gender-dropdown-provider";

interface GenderSelectorProps {
  onSelectGender: (gender?: Filter) => void;
}

const GenderSelector = ({ onSelectGender }: GenderSelectorProps) => {
  const genders = $filters.genderFilters;
  const { value, setValue } = useGenderDropdownContext();
  const handleGenderSelect = (option?: DropdownSelectorOption) => {
    if (option) {
      const selectedGender = $filters.genderFilters.find(
        (gender) => gender.id === option.id,
      );
      onSelectGender(selectedGender);
      setValue(selectedGender);
    } else {
      onSelectGender();
      setValue();
    }
  };

  return (
    <Dropdown
      selectedOption={value}
      items={genders}
      placeholder="Gender"
      onSelect={handleGenderSelect}
    />
  );
};

export default GenderSelector;
